exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#modal-common-product-preview .main-image img,#modal-common-product-preview .thumbnails img{width:100%}", ""]);

// exports
